import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
	SdfAlert,
	SdfFocusPane,
	SdfRadioButton,
	SdfRadioGroup,
} from '@waypoint/react-components';
import wmFetch from '../../../funcs/wmFetch';

const SwitchModal = (props) => {
	const {
		isOpen,
		onClose,
		personaMode,
	} = props;

	const [newPersonaMode, setNewPersonaMode] = useState(personaMode);
	const [saving, setSaving] = useState(false);
	const [errorMessage, setErrorMessage] = useState(null);

	const onChange = (e) => {
		const { value } = e.detail;
		setNewPersonaMode(value);
	};

	const handleClose = () => {
		setNewPersonaMode(personaMode);
		setErrorMessage(null);
		onClose();
	};

	const handleSave = () => {
		setSaving(true);
		setErrorMessage(null);

		wmFetch('/v3/user/update-persona', { newPersonaMode })
			.then(() => {
				onClose();
				setTimeout(() => {
					window.location = '/home';
				}, 100);
			})
			.catch((error) => {
				setErrorMessage(error.message || 'An error occurred');
				setSaving(false);
			});
	};

	return (
		<SdfFocusPane
			data-attr-id="persona-mode-switch-modal"
			portalEnabled
			closeable
			size="sm"
			visible={isOpen}
			heading="Switch experience"
			closeIconTitle="Close"
			onSdfDismiss={handleClose}
			acceptLabel="Update"
			disableAcceptButton={personaMode === newPersonaMode}
			busyAcceptButton={saving}
			onSdfAccept={handleSave}
		>
			<div className="p-4">
				{errorMessage && (
					<SdfAlert
						data-attr-id="persona-mode-switch-modal-error-banner"
						className="mb-4"
						type="banner"
						size="sm"
						status="error"
					>
						{errorMessage}
					</SdfAlert>
				)}

				<SdfRadioGroup
					data-attr-id="persona-mode-switch-radios"
					label="Choose experience"
					onSdfChange={onChange}
					value={newPersonaMode}
				>
					<SdfRadioButton value="BUYER" label="Client" />
					<SdfRadioButton value="SELLER" label="Contractor" />
					<SdfRadioButton value="DISPATCHER" label="Team agent" />
				</SdfRadioGroup>
			</div>
		</SdfFocusPane>
	);
};

SwitchModal.propTypes = {
	isOpen: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
	personaMode: PropTypes.string.isRequired,
};

export default SwitchModal;